<template>
<div class="inpBox">
  <div class="detailsTitle">
    <h4>修改订单</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="getRules()"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-form-item label="结算客户 :" prop="payee" class="width1" label-width="120px">
      <el-select  v-model="goodform.payee" filterable placeholder="请选择" @change="jiesuanChange">
        <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="外部单号:" label-width="120px" class="width1"  >
      <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
    </el-form-item>
    <el-form-item label="项目名称:" prop="projectType"  class="width1" label-width="120px" >
      <el-select  v-model="goodform.projectType" filterable placeholder="请选择">
        <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="业务类型:" class="width1" label-width="120px"  >
      <el-select  v-model="goodform.orderBusinessType"  placeholder="请选择">
        <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
     <el-form-item label="提货仓库:" prop="pickupWarehouse"  class="width1" label-width="120px" >
      <el-select  v-model="goodform.pickupWarehouse"  placeholder="请选择">
          <el-option  label="本库" value="本库" ></el-option>
          <el-option  label="外库" value="外库" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="销售合同:"  class="width1 jiage" label-width="120px">
      <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
       <el-button type="text" class="danwei" @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
    </el-form-item>
    <!-- <el-form-item label="合同结束日期:"  label-width="120px" class="width1" v-if="goodform.salesContract">
      <div style="width:260px">{{goodform.contractEndDate|dateFormat1}}</div>
    </el-form-item>
    <el-form-item label="合同提醒天数:" prop="contractReminderDays" v-if="goodform.salesContract" :rules="goodform.salesContract ?  { required: true, message: '请输入合同提醒天数', trigger: 'blur' }:[{required: false}]"  label-width="120px" class="width1">
      <el-input  placeholder=""  maxlength="50"  v-model="goodform.contractReminderDays"></el-input>
    </el-form-item>
    <el-form-item label="账期预警节点" prop="accountNodeSet"  class="width1" label-width="120px" >
      <el-select  v-model="goodform.accountNodeSet"  placeholder="请选择">
          <el-option  label="装船" value="0" ></el-option>
          <el-option  label="到港" value="1" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="账期预警天数:" prop="accountReminderDays" v-if="goodform.accountNodeSet" :rules="goodform.accountNodeSet ?  { required: true, message: '请输入账期预警天数', trigger: 'blur' }:[{required: false}]"  label-width="120px" class="width1">
      <el-input  placeholder=""  maxlength="50"  v-model="goodform.accountReminderDays"></el-input>
    </el-form-item> -->
    <el-form-item label="业务部门:" prop="insuranceInfo" class="width1" label-width="120px"  >
      <div style="width:260px">{{goodform.businessSubunit}}</div>
    </el-form-item>
    <el-form-item label="业务人员:" prop="businessUserId" class="width1" label-width="120px">
      <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
      <el-select v-else  v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
        <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
      </el-select>
    </el-form-item>

    <hr>
    <!-- 地址组件 -->
    <addDizhi :goodform="goodform" ></addDizhi>
    <hr>
    <!-- 添加货物外库 -->
    <div v-if="goodform.stowageType==2&&goodform.orderSource==9">
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
      </div>
      <el-form-item  label="货物类型:" >
          <div style="width:80px">{{goodform.productTypeName}}</div>
      </el-form-item>
      <el-form-item  label="计量单位:" >
          <div style="width:80px">{{goodform.measuringUnit}}</div>
      </el-form-item>
      <el-form-item  label="重量(吨):">
          <div style="width:80px">{{goodform.weight?goodform.weight:'-'}}</div>
      </el-form-item>
      <el-form-item  label="数量(件):">
          <div style="width:80px">{{goodform.orderNumber?goodform.orderNumber:'-'}}</div>
      </el-form-item>
      <div style="padding:0 16px 16px 16px;" v-if="goodform.goodsList.length>0">
        <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true"  prop="customerName"
            label="货权客户" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
            min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        </el-table>
      </div>
    </div>
    <div v-else>
    <addGoodWaiku :goodform="goodform"  :glhwFlag="glhwFlag"></addGoodWaiku>
    </div>
    <div class="addressBox" style="margin-top:20px">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>运输要求</span>
        </h4>
        <el-form-item label="要求到达时间:" prop="arrivalTime" label-width="120px">
            <el-date-picker
              v-model="goodform.arrivalTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="需求车型:"   >
          <el-select  v-model="goodform.requiredModel" filterable placeholder="请选择">
            <el-option v-for="item in CXlist" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求车长:"   >
          <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
            <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回单要求:" prop="receiptRequest"   >
          <el-select  v-model="goodform.receiptRequest"  placeholder="请选择">
             <el-option  label="纸质回单" value="纸质回单" ></el-option>
             <el-option  label="电子回单" value="电子回单" ></el-option>
             <el-option  label="否" value="否" ></el-option>
          </el-select>
        </el-form-item>
        <br>
        <el-form-item label="提货到场时间:" label-width="120px">
            <el-date-picker
              v-model="goodform.pickupTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="提货紧急程度:" label-width="160px">
          <el-radio-group v-model="goodform.urgencyFlag"    >
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">紧急</el-radio>
            <el-radio :label="2">加急</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
        <div>
          <el-tag style="margin:10px 10px;cursor: pointer;" v-for="item in elTags"
            :key="item"   @click="tagClick(item)" effect="plain">
            {{ item}}
          </el-tag>
        </div>
        <el-form-item label="备注:" class="remark" prop="remark" label-width="53px">
          <el-input  placeholder=""  maxlength="500" v-model="goodform.remark"></el-input>
        </el-form-item>
      </div>
      <shouru :goodform="goodform"></shouru>
      <hr>
      <div class="addressBox inpBox" >
        <h4 class="title">
          <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>支出信息</span>
        </h4>
        <el-form-item label="转包对象:" v-if="goodform.payer">
          {{goodform.payer}}
        </el-form-item>
        <el-form-item label="收款方:" v-if="goodform.payer" >
          {{goodform.payer}}
        </el-form-item>
        <zhichu1 :goodform="goodform"  v-if="goodform.subcontractType==1"></zhichu1>
        <zhichu :goodform="goodform" v-else ></zhichu>
      </div>
      <hr>
      <uploadFiles :fileArr.sync='fileArr' :max=10 @remove="remove"></uploadFiles>
  </el-form>
  <div class="footerBtn">
    <el-button  class="bigBtn"  btnCode="004P001B001"  @click="back">取消</el-button>
    <el-button type="primary" class="bigBtn"  btnCode="004P001B000"  @click="saveFn">提交</el-button>
  </div>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { getDictionaryDetailList, findCustomerInfoList, updateOrder, getOrderInfo, updateSgStowageMainOrder } from '@/api/newTMS'
import { cVLlist, cVTlist } from '@/api/vgs-driver2.0'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import addGoodWaiku from '@/views/newTMS/publicFiles/wayAndOrder/addGoodWaiku.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import shouru from '@/views/newTMS/publicFiles/wayAndOrder/shouru.vue'
import zhichu from '@/views/newTMS/publicFiles/wayAndOrder/zhichu.vue'
import zhichu1 from '@/views/newTMS/publicFiles/wayAndOrder/zhichu1.vue'
export default {
  components: {
    addDizhi, addGoodWaiku, uploadFiles, guanlianhetong, shouru, zhichu, zhichu1
  },
  data () {
    return {
      id: this.$route.query.id,
      glhwFlag: this.$route.query.flag.toString(),
      goodform: {
        goodsList: [],
        smeasuringUnit: '吨'
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      CXlist: [], // 车型
      CClist: [], // 车长
      fileArr: [],
      GLHTflag: false, // 关联合同
      deleteAttachmentsIds: [],
      tOrderBusiness: {},
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      elTags: ['需要架子', '需要棉被'],
      tagArr: [],
      XMlist: []
    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    cVTlist().then(res => { this.CXlist = res })
    cVLlist().then(res => { this.CClist = res })
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.id) { // 列表复制按钮跳转过来
      getOrderInfo({ orderBusinessId: this.id }).then(res => {
        this.goodform = res.tOrder
        this.goodform.deleteOrderGoodsRelIds = []
        this.tOrderBusiness = res.tOrderBusiness
        this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tOrderBusiness.payeeTaxId)
        this.$set(this.goodform, 'settlementCustomersCode', res.tOrderBusiness.settlementCustomersCode)
        this.$set(this.goodform, 'orderBusinessType', res.tOrder.orderBusinessType.toString())
        this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
        this.$set(this.goodform, 'goodsList', res.goodslist)

        this.$set(this.goodform, 'goodsList', res.goodslist)
        this.$set(this.goodform, 'kilometres', res.tOrder.kilometres.toString())

        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }

        for (var key in res.tOrderBusiness) {
          if (key != 'id') {
            this.$set(this.goodform, key, res.tOrderBusiness[key])
          }
        }
        if (res.tOrderBusiness.incomePattern.toString()) {
          this.$set(this.goodform, 'incomePattern', res.tOrderBusiness.incomePattern.toString())
          this.$set(this.goodform, 'incomePatternName', res.tOrderBusiness.incomePatternName)
        }
        if (res.tOrderBusiness.revenueValuation.toString()) {
          this.$set(this.goodform, 'revenueValuation', res.tOrderBusiness.revenueValuation.toString())
          this.$set(this.goodform, 'revenueValuationName', res.tOrderBusiness.revenueValuationName)
        }
        this.$set(this.goodform, 'incomeUnitPrice', res.tOrderBusiness.incomeUnitPrice / 100)
        this.$set(this.goodform, 'incomeAmount', res.tOrderBusiness.incomeAmount / 100)
        // 转包得需要收改支出
        if (res.tOrderBusiness.expenditurePattern || res.tOrderBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tOrderBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tOrderBusiness.expenditurePatternName)
        }
        if (res.tOrderBusiness.freightPricingType || res.tOrderBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tOrderBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tOrderBusiness.freightPricingTypeName)
        }
        if (res.tOrderBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tOrderBusiness.freightUnitPrice / 100)
        }
        if (res.tOrderBusiness.freightAmount) {
          this.$set(this.goodform, 'allFreightAmount', res.tOrderBusiness.freightAmount / 100)
          this.$set(this.goodform, 'freightAmount', res.tOrderBusiness.freightAmount / 100)
        }
        res.tAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })
        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json[0].businessUserCode) {
              this.ywyhFlag = true
            } else {
              this.ywyhFlag = false
            }
          })
        })
      })
    }
  },
  mounted () {

  },
  methods: {
    getRules () {
      return {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        orderWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: this.goodform.stowageType == 1, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: this.goodform.stowageType == 1, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: this.goodform.stowageType == 1, message: '请输入运费单价', trigger: 'blur' }
        ],
        freightAmount: [
          { required: this.goodform.stowageType == 1, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        deliverPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的发货人' }
        ],
        receivingPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的收货人' }
        ],
        pickupWarehouse: [
          { required: true, message: '请选择提货仓库', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请输入收入税率', trigger: 'blur' }
        ]
      }
    },
    tagClick (item) {
      this.tagArr.push(item)
      this.tagArr = Array.from(new Set(this.tagArr))
      this.$set(this.goodform, 'remark', this.tagArr.toString())
    },
    remarkFn () {
      if (!this.goodform.remark) {
        this.tagArr = []
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.deleteAttachmentsIds.push(file.id)
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }
      this.goodform.originalCustomer = this.goodform.payee// 下单客户
    },
    xuanzeHT () {
      if (this.goodform.payee) {
        this.GLHTflag = true
      } else {
        this.$alert('请先选择结算客户', '系统提示')
      }
    },
    saveFn (n) {
      const newArr = this.goodform.goodsList.map(item => item.cargoBarcode)
      const arrSet = new Set(newArr)
      if (arrSet.size !== newArr.length) {
        this.$alert('捆包号不能重复', '系统提示')
        return
      }
      if (!this.goodform.orderWeight) {
        this.$alert('订单量不能为0', '系统提示')
        return
      }
      if (!this.goodform.kilometres) {
        this.$alert('公里数不能为空，请联系系统管理员', '系统提示')
        return
      }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.orderBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.orderBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'orderBusinessType', null)
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let data = {}
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            data.payeeCode = json[0].tenantCode
          }
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }
          data.tOrder = this.goodform
          data.goodslist = []// 修改只传新加的值
          this.goodform.goodsList.forEach(item => {
            if (!item.orderGoodsRelId) {
              data.goodslist.push(item)
            }
          })
          data.deleteOrderGoodsRelIds = this.goodform.deleteOrderGoodsRelIds
          data.deleteAttachmentsIds = this.deleteAttachmentsIds

          data.tOrderBusiness = this.tOrderBusiness// 把业务实体整个赋值
          data.tOrderBusiness.payeeTaxId = this.goodform.payeeTaxId
          data.tOrderBusiness.payee = this.goodform.payee
          data.tOrderBusiness.incomePattern = this.goodform.incomePattern
          data.tOrderBusiness.makeTicketYn = this.goodform.makeTicketYn
          data.tOrderBusiness.ticketSystemYn = this.goodform.ticketSystemYn
          data.tOrderBusiness.revenueValuation = this.goodform.revenueValuation
          data.tOrderBusiness.incomePatternName = this.goodform.incomePatternName
          data.tOrderBusiness.revenueValuationName = this.goodform.revenueValuationName
          data.tOrderBusiness.incomeUnitPrice = this.goodform.incomeUnitPrice
          data.tOrderBusiness.incomeAmount = this.goodform.incomeAmount
          data.tOrderBusiness.expenditurePattern = this.goodform.expenditurePattern
          data.tOrderBusiness.freightPricingType = this.goodform.freightPricingType
          data.tOrderBusiness.expenditurePatternName = this.goodform.expenditurePatternName
          data.tOrderBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
          data.tOrderBusiness.freightUnitPrice = this.goodform.freightUnitPrice
          data.tOrderBusiness.freightAmount = this.goodform.freightAmount
          data.tOrderBusiness.serviceRate = this.goodform.serviceRate
          data.tOrderBusiness.serviceCharge = this.goodform.serviceCharge
          data.tOrderBusiness.freightTaxRate = this.goodform.freightTaxRate
          data.tOrderBusiness.taxRate = this.goodform.taxRate
          console.log(data)
          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(data))
          this.fileArr.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          if (this.goodform.stowageType == 2) {
            updateSgStowageMainOrder(imgfile).then(res => {
              loading.close()
              this.$router.push({ name: 'qiYunOrder' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            updateOrder(imgfile).then(res => {
              loading.close()
              this.$router.push({ name: 'qiYunOrder' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.width1  /deep/.el-input__inner{
  width: 260px;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
hr{
  margin-bottom: 20px;
}
/deep/.remark .el-input .el-input__inner{
  width: 788px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
/deep/.el-range-editor{
  width: 430px;
}
</style>
